export default "__VITE_ASSET__4bfe1ebd__"